<template>
 <div>
    <div class="bg-light rounded-2 mx-lg-10">
      <div class="container content-space-2">
        <div class="row justify-content-center">
          <div class="col-sm-6 col-md-4 mb-7 mb-md-0">
            <!-- Stats -->
            <div class="text-center">
              <h2 class="display-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="3.5rem" height="3.5rem" fill="currentColor" class="bi bi-arrow-down-short text-danger" viewBox="0 0 16 16">
               <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                </svg>87%</h2>
              <p class="mb-0">Human<br>Error</p>
            </div>
            <!-- End Stats -->
          </div>
          <!-- End Col -->

          <div class="col-sm-6 col-md-4 mb-7 mb-md-0">
            <!-- Stats -->
            <div class="text-center">
              <h2 class="display-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="3.5rem" height="3.5rem" fill="currentColor" class="bi-arrow-up-short text-success" viewBox="0 0 16 16">
                 <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
                </svg>32%</h2>
              <p class="mb-0">Resources<br>Usage</p>
            </div>
            <!-- End Stats -->
          </div>
          <!-- End Col -->

          <div class="col-sm-6 col-md-4">
            <!-- Stats -->
            <div class="text-center">
              <h2 class="display-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="3.5rem" height="3.5rem" fill="currentColor" class="bi-arrow-up-short text-success" viewBox="0 0 16 16">
                 <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
                </svg>49.3%</h2>
              <p class="mb-0">Accuracy<br>Efficiency</p>
            </div>
            <!-- End Stats -->
          </div>
          <!-- End Col -->
        </div>
        <!-- End Row -->
      </div>
    </div>
    
 </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>

.content-space-2 {
    padding-top: 5rem!important;
    padding-bottom: 5rem!important;
}

@media (min-width: 1200px)
{
  .container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 1140px;
}
}

.bi-arrow-up-short::before {
    content: "\f145";
}

.bi::before, [class^="bi-"]::before, [class*=" bi-"]::before {
    display: inline-block;
    font-family: bootstrap-icons !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: -0.125em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.bi-arrow-down-short::before {
    content: "\f124";
    
}

.bi::before, [class^="bi-"]::before, [class*=" bi-"]::before {
    display: inline-block;
    font-family: bootstrap-icons !important;
    font-style: normal;
    font-weight: normal !important;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: -0.125em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.display-4 {
    font-size: calc(1.475rem + 2.7vw);
    font-weight: 600;
    line-height: 1.2;
}



@media (min-width: 1200px) {
.display-4 {
    font-size: 3.5rem;
}
}

@media (min-width: 768px){
.col-md-4 {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: 33.33333%;
}
}



</style>